import { RootRoute } from "#src/routes/root";
import { RoutePath } from "#src/utils/route";

export const FORMS_BREADCRUMB = { title: "Forms" };

export const FormsRoute = RootRoute.concat(
  new RoutePath({
    path: "/forms",
    title: "Forms",
    isPresentational: true,
  })
);
